let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jEuPM")).then(() => parcelRequire('bbnmk'));